import type { ErrorResponse } from 'react-router'
import { Link } from 'react-router'
import { Button } from '~/components/ui'

type ServerErrorProps = {
  response: ErrorResponse
}

export default function ServerError({ response }: ServerErrorProps) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center">
      <div className="space-y-6 text-center">
        <h1 className="text-9xl font-bold text-neutral-800">
          {response.status}
        </h1>
        <p className="text-2xl text-neutral-600">Server Error</p>
        <p className="text-neutral-500">
          {response.statusText.length > 0
            ? response.statusText
            : 'Something went wrong on our end. Please try again later.'}
        </p>
        <Button asChild>
          <Link to="/" className="mt-6 inline-block">
            Go Back Home
          </Link>
        </Button>
      </div>
    </div>
  )
}
